import React from 'react';
import DocumentoNoDisponible from './DocumentoNoDisponible';

const CompendioCap5 = () => (
  <DocumentoNoDisponible titulo="Compendio Estadístico 2017 - 2021 · Capítulo 5" />
);

export default CompendioCap5;
